/*
 * GMAN free-shipping gap closer (snippets/gman-ship-gap.liquid).
 * Reads /cart.js, and while the cart is under the threshold offers one item
 * that closes the gap, matched to the latest item's color and size.
 * Re-checks on every cart update (theme publishes PUB_SUB_EVENTS.cartUpdate).
 */
(function () {
  if (customElements.get('gman-ship-gap')) return;
  /* UI text: window.GMAN_T comes from snippets/gman-i18n.liquid (locale keys gman.js.*). The English fallback keeps the store working if that snippet is missing. */
  function T(k, en, vars) {
    var s = window.GMAN_T && window.GMAN_T[k] != null ? window.GMAN_T[k] : en;
    if (vars) Object.keys(vars).forEach(function (v) { s = s.split('{' + v + '}').join(vars[v]); });
    return s;
  }

  var SIZE_ALIASES = {
    XS: 'XS', XSM: 'XS', S: 'S', SM: 'S', SMALL: 'S', M: 'M', MD: 'M', MED: 'M', MEDIUM: 'M',
    L: 'L', LG: 'L', LARGE: 'L', XL: 'XL', XLG: 'XL', '2X': '2XL', '2XL': '2XL', XXL: '2XL',
    '3X': '3XL', '3XL': '3XL', XXXL: '3XL', '4X': '4XL', '4XL': '4XL', '5X': '5XL', '5XL': '5XL', '6X': '6XL', '6XL': '6XL'
  };
  function canonSize(raw) {
    if (raw == null) return '';
    var s = String(raw).toUpperCase().replace(/\(.*?\)/g, '').replace(/[\s\-_.]/g, '');
    return SIZE_ALIASES[s] || String(raw).trim().toUpperCase();
  }
  function money(cents) { return '$' + ((cents || 0) / 100).toFixed(2); }
  function optIndex(names, key) {
    for (var i = 0; i < names.length; i++) if (String(names[i]).toLowerCase().indexOf(key) !== -1) return i;
    return -1;
  }
  // "A-Shirt Tank Tops - 6/Pack" -> "A-Shirt Tank Tops, 6/Pack"
  function cleanTitle(t) { return String(t || '').replace(/\s+[-–—]\s+/g, ', '); }
  function track(event, data) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: event }, data || {})); } catch (e) {}
  }

  /* Pure decision logic, exposed for tests: returns null or the offer to show. */
  function decide(cart, data, threshold) {
    if (!cart || !cart.items || !cart.items.length) return null;
    var total = cart.total_price || 0;
    if (total >= threshold) return null;
    var gap = threshold - total;

    // latest item that has a size, else the latest item
    var ref = null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if ((it.options_with_values || []).some(function (o) { return /size|talla/i.test(o.name); })) { ref = it; break; }
    }
    if (!ref) ref = cart.items[0];
    var refSize = '', refColor = '';
    (ref.options_with_values || []).forEach(function (o) {
      if (/size|talla/i.test(o.name)) refSize = canonSize(o.value);
      else if (/colo/i.test(o.name)) refColor = o.value;
    });

    function pickVariant(p) {
      if (!p || !refSize) return null;
      var ci = optIndex(p.options, 'colo');
      var si = optIndex(p.options, 'size'); if (si === -1) si = optIndex(p.options, 'talla');
      if (si === -1) return null;
      var sized = p.variants.filter(function (v) { return v.available && canonSize(v.options[si]) === refSize; });
      if (!sized.length) return null;
      var match = null;
      if (ci > -1 && refColor) match = sized.filter(function (v) { return v.options[ci] === refColor; })[0];
      if (!match && ci > -1) {
        ['Black', 'White', 'Negro', 'Blanco'].some(function (c) { match = sized.filter(function (v) { return v.options[ci] === c; })[0]; return !!match; });
      }
      match = match || sized[0];
      return { id: match.id, price: match.price, color: ci > -1 ? match.options[ci] : '', size: match.options[si] };
    }

    var refIsOffer = data.offer && ref.product_id === data.offer.id;
    var product = refIsOffer ? data.partner : data.offer;
    var image = refIsOffer ? data.partnerImage : data.offerImage;
    var v = pickVariant(product);
    if (v && v.price >= gap) {
      return {
        kind: refIsOffer ? 'partner' : 'offer', variantId: v.id, price: v.price, newTotal: total + v.price,
        title: cleanTitle(product.title), variant: [v.color, v.size].filter(Boolean).join(' / '),
        sameAs: !!refSize, image: image, gap: gap
      };
    }
    // nothing in their size closes the gap: offer one more of what they picked
    var unit = ref.final_price != null ? ref.final_price : ref.price;
    // items carrying app options (Easify line item properties) can't be re-added blind
    var hasProps = ref.properties && Object.keys(ref.properties).some(function (k) { return ref.properties[k] !== '' && ref.properties[k] != null; });
    if (unit >= gap && ref.variant_id && !hasProps) {
      return {
        kind: 'repeat', variantId: ref.variant_id, price: unit, newTotal: total + unit,
        title: cleanTitle(ref.product_title), variant: ref.variant_title || '',
        sameAs: false, image: ref.image || '', gap: gap
      };
    }
    return null;
  }

  class GmanShipGap extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try { this.data = JSON.parse(this.querySelector('[data-gap-products]').textContent); } catch (e) { this.data = {}; }
      this.threshold = parseInt(this.dataset.threshold, 10) || 5000;
      this.btn = this.querySelector('[data-gap-add]');
      this.btn.addEventListener('click', () => this.add());
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
        this._unsub = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
      // drawer opens after a product-form add; re-check in case an add skipped pub/sub
      this._onOpen = () => this.refresh();
      document.addEventListener('cart:refresh', this._onOpen);
      this.refresh();
    }

    disconnectedCallback() {
      if (this._unsub) this._unsub();
      document.removeEventListener('cart:refresh', this._onOpen);
    }

    refresh() {
      var url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then((cart) => this.render(decide(cart, this.data || {}, this.threshold)))
        .catch(() => this.render(null));
    }

    render(o) {
      this.offer = o;
      this.hidden = !o;
      if (!o) return;
      var q = (s) => this.querySelector(s);
      q('[data-gap-title]').textContent = o.kind === 'repeat' ? T('gap_add_one_more', 'Add one more: {title}', { title: o.title }) : T('gap_add', 'Add {title}', { title: o.title });
      q('[data-gap-variant]').textContent = o.variant + (o.sameAs ? T('gap_same_size', ', same size as your order') : '');
      q('[data-gap-math]').textContent = T('gap_math', '{price} brings your order to {total}. Shipping is free.', { price: money(o.price), total: money(o.newTotal) });
      this.btn.textContent = T('gap_btn', 'Add and ship free, {price}', { price: money(o.price) });
      this.btn.disabled = false;
      var img = q('[data-gap-img]');
      if (o.image) { img.src = o.image; img.alt = o.title; img.hidden = false; } else { img.hidden = true; }
      q('[data-gap-error]').hidden = true;
      if (this._shownFor !== o.variantId) {
        this._shownFor = o.variantId;
        track('gman_ship_gap_view', { kind: o.kind, variant_id: o.variantId, gap_cents: o.gap });
      }
    }

    add() {
      var o = this.offer;
      if (!o) return;
      this.btn.disabled = true;
      var drawer = document.querySelector('cart-notification');
      var body = { items: [{ id: o.variantId, quantity: 1 }] };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then((res) => {
          if (res.status) throw new Error(res.description || res.message || T('gap_error', 'Could not add that item.'));
          track('gman_ship_gap_add', { kind: o.kind, variant_id: o.variantId, value: o.price / 100 });
          if (drawer && res.sections && typeof drawer.renderContents === 'function') drawer.renderContents(res);
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gman-ship-gap', cartData: res });
          } else {
            this.refresh();
          }
        })
        .catch((e) => {
          this.btn.disabled = false;
          var err = this.querySelector('[data-gap-error]');
          err.textContent = e.message || T('gap_error', 'Could not add that item.');
          err.hidden = false;
        });
    }
  }

  customElements.define('gman-ship-gap', GmanShipGap);
  window.GMAN_SHIP_GAP = { decide: decide };
})();
